import { getApiClient } from 'apiClient';
import { type AxiosRequestConfig } from 'axios';
import { type MediaDataObject } from 'models/services';
import { routes } from './routes';

type BodyRequest = {
  mimeType: string;
  name: string;
  ref: string;
  type: string;
};

type CreateChunkedUploadResponse = MediaDataObject;

export const createChunkedUpload = async ({ body, config }: { body: BodyRequest; config: AxiosRequestConfig }) =>
  getApiClient().post<CreateChunkedUploadResponse>(routes.chunkedUpload.create, body, config);
